<script lang="ts" setup>
import Card from 'primevue/card';

const {
  title = '',
  subtitle = '',
  width = 'auto',
} = defineProps<{
  title?: string;
  subtitle?: string;
  width?: string | number;
}>();
</script>

<template>
  <Card :style="{ width }" class="app-card border border-gray-200">
    <template v-if="$slots.header" #header>
      <slot name="header" />
    </template>
    <template v-if="title" #title>{{ title }}</template>
    <template v-if="subtitle" #subtitle>{{ subtitle }}</template>
    <template #content>
      <slot />
    </template>
    <template v-if="$slots.footer" #footer>
      <slot name="footer" />
    </template>
  </Card>
</template>

<style lang="scss" scoped>
// Match the app-wide card radius scale ($radius-lg) instead of PrimeVue's
// own `.p-card` preset radius, which doesn't align with the design tokens
// used by every other card surface (CandidateCard, PartyCard, etc.).
// Compound selector needed to outrank `.p-card`'s equal-specificity rule
// regardless of stylesheet insertion order (PrimeVue injects its styles
// at component-mount time, which can land after this scoped style).
.app-card.p-card {
  border-radius: $radius-lg;
}
</style>
